module.exports = __webpack_public_path__ + "img/financle-cloud.5e5e55f6.png";